import moment from "moment";
import { AdjustRateParams, InvoiceRequestParams } from "../model";
import { getEffortsDetails, getWorkingDaysInMonth, getWorkingDaysPerMonth } from "../pages/report/payments/efforts";
import { parseClassNames } from "@fullcalendar/core/internal";

export async function getFinanceAgregatedDetails(filters: any) {
    //FIXME
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "select _d, count(_d), f.hrs * p.rate as bill  , sum(payment), sum(verified), sum(hrs) from finance as f left join project as p on f.uuid = p.uuid and p.active = true group by _d",
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function getFinanceDetails(filters: any) {
    //FIXME - Date, User, Project

    let _q = "select *, p.rate * f.hrs as bill from finance as f left join consultant as c on f.uuid = c.uuid left join project as p on p.uuid = c.uuid and '" + filters.date + "' between p.start_dt and p.end_dt  where 1=1 ";
    if (filters.date) {
        _q += "and _d = " + "'" + filters.date + "'";
    }

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}
export async function getFinanceReportData(filters: any) {
    // console.log(filters);
    try {
        let _q =
            "SELECT  SUM(IFNULL(finance.payment, 0)) as payment, month(_d) as m, _d, MONTHNAME(_d)  as month1, YEAR(_d) AS year, DATE_FORMAT(_d, '%Y-%m') AS month, sum(project.rate * finance.hrs) as bill, sum(hrs) as hrs, invoice_no, (ROUND(COALESCE(sum(project.rate * finance.hrs),0),2)-ROUND(COALESCE(sum(finance.payment),0),2)) as diff, (COALESCE((fixed_payroll),0)-COALESCE(sum(finance.payment),0)) as fixed_diff, finance.uuid ,project_master.name,consultant.name,project.rate as prate, project.rate as rate from finance LEFT JOIN consultant ON consultant.uuid =finance.uuid LEFT JOIN project ON consultant.uuid = project.uuid  AND _d BETWEEN project.start_dt AND project.end_dt LEFT JOIN project_master ON project.pid = project_master.pid  ";
        _q += " where 1=1 ";
        if (filters && filters.checkDate) {
            _q += "  and month(_d) = " + (filters.checkDate.getMonth() + 1) + "";
            _q += "  and year(_d) = " + filters.checkDate.getFullYear() + "";
        }

        if (filters && filters.employee) {
            _q += "  and finance.uuid = '" + filters.employee + "' ";
        }

        _q += " group by uuid, consultant.name, month1, year ";

        _q += " order by consultant.name asc, _d asc ";

        console.log(_q);

        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function getDuplicateInvoiceNumber() {
    console.log("Fetching duplicate invoice numbers...");
    const _q = `
       SELECT 
            invoice_no, 
            MONTH(_d) as month, 
            YEAR(_d) as year, 
            GROUP_CONCAT(DISTINCT uuid) as uuids,
            COUNT(DISTINCT uuid) as uuid_count
        FROM finance
        WHERE invoice_no IS NOT NULL AND invoice_no <> ''
        GROUP BY invoice_no
        HAVING uuid_count > 1
        ORDER BY year DESC, month DESC, invoice_no
    `;

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function getFinanceReportDataByIkat(filters: any) {
    // console.log(filters);
    try {
        let _q =
            "SELECT  SUM(IFNULL(finance.payment, 0)) as payment, month(_d) as m, _d, project_master.name AS pid, MONTHNAME(_d)  as month1, YEAR(_d) AS year, DATE_FORMAT(_d, '%Y-%m') AS month, _ts_bill, DATE_FORMAT(_ts_bill, '%Y-%m') AS billMonth, _ts_invoice_due, DATE_FORMAT(_ts_invoice_due, '%Y-%m') AS invoiceDueMonth, sum(project.rate * finance.hrs) as bill, sum(hrs) as hrs, invoice_no, (COALESCE(sum(project.rate * finance.hrs),0)-COALESCE(sum(finance.payment),0)) as diff, (COALESCE((fixed_payroll),0)-COALESCE(sum(finance.payment),0)) as fixed_diff, (sum(hrs) - COALESCE(sum(payment),0)/project.rate) as balance_hrs, finance.uuid ,project_master.name,consultant.name,project.rate as prate, project.rate as rate from finance LEFT JOIN consultant ON consultant.uuid =finance.uuid LEFT JOIN project ON consultant.uuid = project.uuid AND _d BETWEEN project.start_dt AND project.end_dt  LEFT JOIN project_master ON project.pid = project_master.pid ";
        _q += " where 1=1 and project_master.name= 'IKAT' ";
        if (filters && filters.checkDate) {
            _q += "  and month(_d) = " + (filters.checkDate.getMonth() + 1) + "";
            _q += "  and year(_d) = " + filters.checkDate.getFullYear() + "";
        }

        if (filters && filters.employee) {
            _q += "  and finance.uuid = '" + filters.employee + "' ";
        }

        _q += " group by uuid, consultant.name,  project_master.pid, month1, year ";

        _q += " order by consultant.name asc ";

        console.log(_q);

        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function getInvoicesData(filters: any) {
    console.log(filters);

    try {
        let _q = `
            SELECT 
                finance.uuid, 
                finance._d as _d, 
                finance._ts_invoice, 
                finance._ts_invoice_due,  
                consultant.name, 
                project_master.name AS pid, 
                DATE_FORMAT(_d, '%Y-%m') AS month, 
                month(_d) as m, 
                MONTHNAME(_d) AS month1, 
                YEAR(_d) AS year, 
                CASE WHEN project.billing_period = 'Weekly' THEN WEEK(_d, 1) ELSE NULL END AS calendar_week, 
                CASE WHEN project.billing_period = 'Weekly' THEN 'Weekly' ELSE 'Monthly' END AS billing_group, 
                
                SUM(project.rate * finance.hrs) AS bill_wo_deductions,

                COALESCE(SUM(project.rate * finance.hrs),0) - ((COALESCE(SUM(project.rate * finance.hrs),0)) * (project.insurance_fee + project.vmo) / 100)  AS bill, 

                SUM(hrs) AS hrs, 
                
                SUM(IFNULL(finance.payment, 0)) AS payment, 

                COUNT(DISTINCT finance._d) AS _punched, 
                
                COUNT(DISTINCT finance.invoice_no) AS _invoiced,

                consultant.fixed_payroll,

                project.fixed_payment,

                COALESCE(SUM(project.rate * finance.hrs),0)  - COALESCE(SUM(finance.payment),0) AS diff_wo_deductions,

                COALESCE(SUM(project.rate * finance.hrs),0) - ((COALESCE(SUM(project.rate * finance.hrs),0)) * (project.insurance_fee + project.vmo) / 100) - COALESCE(SUM(finance.payment),0) AS diff,


                COALESCE((project.fixed_payment), 0) - COALESCE(SUM(finance.payment), 0) AS fixed_diff,
                GROUP_CONCAT(DISTINCT project.billing_period) AS billing_period, 
                GROUP_CONCAT(DISTINCT invoice_no) AS invoice_no, 
                MAX(project.rate) AS prate,
                finance.updated_by,

                CASE 
                    WHEN project.billing_period = 'Weekly' THEN DATE_SUB(_d, INTERVAL WEEKDAY(_d) DAY)
                    ELSE DATE_FORMAT(_d, '%Y-%m-01')
                END AS period_start,
                CASE 
                    WHEN project.billing_period = 'Weekly' THEN DATE_ADD(DATE_SUB(_d, INTERVAL WEEKDAY(_d) DAY), INTERVAL 6 DAY)
                    ELSE LAST_DAY(_d)
                END AS period_end, 

            project_master.cid as cid,

            project.insurance_fee as insurance_fee,
            project.vmo as vmo

            FROM finance 

            LEFT JOIN consultant ON consultant.uuid = finance.uuid 
            LEFT JOIN project ON consultant.uuid = project.uuid AND finance.pid = project.pid AND finance._d BETWEEN project.start_dt AND project.end_dt 
            LEFT JOIN project_master ON project.pid = project_master.pid 
            WHERE 1=1 AND hrs > 0
        `;

        if (filters?.employeeStatus !== undefined && filters?.employeeStatus !== "all") {
            _q += ` AND consultant.active = ${filters?.employeeStatus !== "inactive" ? 1 : 0} `;
        }

        if (filters?.checkDate) {
            _q += ` AND MONTH(_d) = ${filters?.checkDate.getMonth() + 1} AND YEAR(_d) = ${filters?.checkDate.getFullYear()} `;
        }

        if (filters?.employee) {
            _q += ` AND finance.uuid = '${filters?.employee}' `;
        }

        if (filters?.yearLimit != undefined && filters?.yearLimit !== null) {
            _q += ` AND YEAR(_d) >= ${filters.yearLimit ? 2025 : 2010} `;
        }

        if (filters?.billingPeriod && filters.billingPeriod !== "all") {
            _q += ` AND project.billing_period = '${filters.billingPeriod}' `;
        }

        if (filters?.clientId && filters.clientId !== "all") {
            _q += ` AND project_master.cid = '${filters.clientId}' `;
        }

        // Group by uuid, pid, rate, and either week or month (depending on billing type)
        _q += ` GROUP BY finance.uuid, consultant.name, project_master.name, YEAR(_d),
            CASE 
                WHEN project.billing_period = 'Weekly' THEN YEARWEEK(_d, 1)
                ELSE MONTH(_d)
            END,
            CASE 
                WHEN project.billing_period = 'Weekly' THEN NULL
                ELSE YEAR(_d)
            END,
            CASE WHEN project.billing_period = 'Weekly' THEN 'Weekly' ELSE 'Monthly' END,
            project.rate
        `;

        _q += ` ORDER BY consultant.name ASC, _d desc, uuid asc, week(_d,1) desc, year(_d) desc, month(_d) desc, project_master.name asc `;

        console.log(_q);

        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        // return await response.json();

        const rows = await response.json(); // your DB fetch
        console.log("Rows fetched:", rows);

        // Post-process rows
        const processedRows = await Promise.all(
            rows?.map(async (row) => {
                const year = moment(row._d).year();
                const month = moment(row._d).month() + 1; // moment: 0-based
                const workingDays = await getWorkingDaysInMonth(year, month);
                row.workingDays = workingDays;

                // Apply Deductions if not on fixed payroll

                

                if(row.insurance_fee || row.vmo) {
                    row.insurance_fee = Number(row.insurance_fee);
                    row.vmo = Number(row.vmo);

                //     row.bill = Number(row.bill_wo_deductions).toFixed(2);
                // row.payment = Number(Number(row.payment).toFixed(2));
                // row.diff = Number(row.diff_wo_deductions).toFixed(2);

                    row.deductions = ((Number(row.bill_wo_deductions)) * (Number(row.insurance_fee) + Number(row.vmo))) / 100;
                    row.billPerDay = (Number((row.bill_wo_deductions - row.deductions)) / Number(row._punched)).toFixed(2);

                } else {
                    row.bill = Number(row.bill_wo_deductions).toFixed(2);
                    row.payment = Number(Number(row.payment).toFixed(2));
                    row.diff = Number(row.diff_wo_deductions).toFixed(2);
                }

                

                if (row.fixed_payroll && row.fixed_payroll > 0) {
                    try {
                        const effortsDetails = await getEffortsDetails(row);
                        if (effortsDetails) {
                            row.effortsDetails = effortsDetails;
                            row.workingDays = effortsDetails && effortsDetails[0]?.working_days;
                        }
                    } catch (error) {
                        console.error("Error fetching efforts details:", error);
                    }
                }

                if (row.fixed_payroll && row.fixed_payroll > 0) {
                    row.fixed_payroll = Number(row.fixed_payroll);
                    row.fixed_payment = Number(row.fixed_payment);

                    row.bill = (Number(row.fixed_payment) / Number(row.workingDays)) * Number(row._punched);
                    row.diff = (Number(row.fixed_diff) / Number(row.workingDays)) * Number(row._punched);

                    row.billPerDay = Number(row.fixed_payment) / Number(row.workingDays);

                    if (row.payment > 0) {
                        row.diff = 0;
                        row.payment = row.bill;
                    }
                } else {

                    // Apply Deductions if not on fixed payroll
                    // row.deductions = ((Number(row.bill_wo_deductions)) * (Number(row.insurance_fee) + Number(row.vmo))) / 100;
                    // row.billPerDay = Number((row.bill_wo_deductions - row.deductions) / Number(row.workingDays)).toFixed(2); FIXME - Already applied above

                    // row.billPerDay = null;
                }

                row.payment = Number(Number(row.payment).toFixed(2));
                row.bill = Number(Number(row.bill).toFixed(2));
                row.diff = Number(Number(row.diff).toFixed(2));

                // finance.updated_by is now included in row

                return row;
            })
        );

        return processedRows;
    } catch (error) {
        console.error(error);
        return [];
    }
}

export async function getFinanceReportDataByMonth(filters: any) {
    // console.log(filters);
    try {
        let _q = `
            SELECT  SUM(IFNULL(finance.payment, 0)) as payment, 
            
            MONTHNAME(_d)  as month1, 
            
            YEAR(_d) AS year, 
            
            DATE_FORMAT(_d, '%Y-%m') AS month,  
            
            sum(project.rate * finance.hrs) as bill, 

            count(DISTINCT finance._d) as _punched,
            
            sum(hrs) as hrs,
            
            (COALESCE(sum( project.rate * finance.hrs),0)-COALESCE(sum(finance.payment),0)) as diff, 

            (COALESCE((fixed_payroll),0)-COALESCE(sum(finance.payment),0)) as fixed_diff, 

            consultant.fixed_payroll,

            project.fixed_payment,
            
            project_master.name,
                        
            project.rate 
            
            from finance 
            
            LEFT JOIN consultant ON consultant.uuid =finance.uuid 
            
            LEFT JOIN project ON consultant.uuid = project.uuid AND _d BETWEEN project.start_dt AND project.end_dt 
            
            LEFT JOIN project_master ON project.pid = project_master.pid
            `;
        _q += " where 1=1 AND hrs > 0 ";

        if (filters && filters.checkDate) {
            _q += "  and year(_d) = " + filters.checkDate.getFullYear() + "";
        }

        _q += " group by month1, year order by _d";

        // console.log(_q);

        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        // return await response.json();

        const rows = await response.json(); // your DB fetch
        console.log("Rows fetched:", rows);

        // Post-process rows
        const processedRows = await Promise.all(
            rows?.map(async (row) => {
                const year = moment(row._d).year();
                const month = moment(row._d).month() + 1; // moment: 0-based
                const workingDays = await getWorkingDaysInMonth(year, month);
                row.workingDays = workingDays;

                if (row.fixed_payroll && row.fixed_payroll > 0) {
                    try {
                        const effortsDetails = await getEffortsDetails(row);
                        if (effortsDetails) {
                            row.effortsDetails = effortsDetails;
                            row.workingDays = effortsDetails && effortsDetails[0]?.working_days;
                        }
                    } catch (error) {
                        console.error("Error fetching efforts details:", error);
                    }
                }

                if (row.fixed_payroll && row.fixed_payroll > 0) {
                    row.fixed_payroll = Number(row.fixed_payroll);
                    row.fixed_payment = Number(row.fixed_payment);

                    row.bill = (Number(row.fixed_payment) / Number(row.workingDays)) * Number(row._punched);
                    row.diff = (Number(row.fixed_diff) / Number(row.workingDays)) * Number(row._punched);

                    row.billPerDay = Number(row.fixed_payment) / Number(row.workingDays);

                    if (row.payment > 0) {
                        row.diff = 0;
                        row.payment = row.bill;
                    }
                } else {
                    row.billPerDay = null;
                }

                row.payment = Number(Number(row.payment).toFixed(2));
                row.bill = Number(Number(row.bill).toFixed(2));
                row.diff = Number(Number(row.diff).toFixed(2));

                // finance.updated_by is now included in row

                return row;
            })
        );

        console.log("Processed Rows:", processedRows);

        return processedRows;
    } catch (error) {
        return [];
    }
}
export async function getOutstandingPayments(filters: any) {
    // console.log(filters);
    try {
        let _q =
            "SELECT  SUM(IFNULL(finance.payment, 0)) as payment, MONTHNAME(_d)  as month1, YEAR(_d) AS year, DATE_FORMAT(_d, '%Y-%m') AS month,sum( project.rate * finance.hrs) as bill, sum(hrs) as hrs,(COALESCE(sum(project.rate * finance.hrs),0)-COALESCE(sum(finance.payment),0)) as diff, (COALESCE((fixed_payroll),0)-COALESCE(sum(finance.payment),0)) as fixed_diff, finance.uuid ,project_master.name,consultant.name,project.rate from finance LEFT JOIN consultant ON consultant.uuid =finance.uuid LEFT JOIN project ON consultant.uuid = project.uuid AND _d BETWEEN project.start_dt AND project.end_dt  LEFT JOIN project_master ON project.pid = project_master.pid ";
        _q += " where 1=1 ";

        if (filters && filters.checkDate) {
            _q += "  and year(_d) = " + filters.checkDate.getFullYear() + "";
        }

        // _q += " group by month1 ";

        _q += " order by _d ";

        // console.log(_q);

        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

// export async function getfinances(request: any) {
//     let query = "";
//     if (this.filteredConsultant) {
//         query = "_d = " + '"' + request + '" and uid = ' + this.filteredConsultant.id;
//     } else if (this.filteredProject) {
//         query = "_d = " + '"' + request + '" and pid = ' + this.filteredProject.project;
//     } else {
//         query = "_d = " + '"' + request + '"';
//     }
//     this.financeService.getFinances(query).subscribe((result: any) => {
//         this.isdateeventclicked = true;
//         this.dialogHeader = "Payment Details";
//         this.finances = result;
//     });
// }

export async function saveFinanceRecord(financeObj: any) {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/finance", {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(financeObj),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

// function is not used
export async function getBillingDetails(filters: any) {
    // console.log(filters);

    let _q = "select distinct uuid, _d, month(_d) as _m, sum(pro) as _bill, sum(payment) as _payment, sum(hrs) as _hrs  from finance as f left join project as p on f.uuid = p.uuid where year(_d) = " + filters.checkDate.getFullYear() + " and month(_d) = " + (filters.checkDate.getMonth() + 1) + "  ";
    if (filters.employee) {
        _q += " and uuid = '" + filters.employee + "' ";
    } else {
        _q += " and uuid is not null and uuid <> '' ";
    }
    _q += " group by month(_d), uuid  ";
    // console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function adjustRate(params: AdjustRateParams) {
    // console.log(params);

    let _q = "UPDATE finance SET rate = " + Number(params.newRate) + " where 1=1 ";

    if (params.uuid) {
        _q += " and uuid = '" + params.uuid + "' ";
    }

    if (params.checkDate) {
        _q += " and month(_d) = " + (params.checkDate.getMonth() + 1) + " and year(_d) = " + params.checkDate.getFullYear();
    }

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function generateInvoice(params: InvoiceRequestParams) {
    console.log(params);

    // Build SET clause dynamically
    let setClauses = [`invoice_no = '${params.invoiceNo}'`, `_ts_invoice = '${moment().format("YYYY-MM-DD")}'`, `_ts_invoice_due = DATE_ADD('${moment().format("YYYY-MM-DD")}', INTERVAL IFNULL(project_master.payment_terms, 30) DAY)`];

    if (params.createdBy) {
        setClauses.push(`finance.created_by = '${params.createdBy}'`);
    }
    if (params.updatedBy) {
        setClauses.push(`finance.updated_by = '${params.updatedBy}'`);
    }

    // The due date is calculated as current date + payment_terms (in days) from the project_master table
    let updateQuery = `
        UPDATE finance
        LEFT JOIN project ON finance.uuid = project.uuid AND finance.pid = project.pid AND finance._d BETWEEN project.start_dt AND project.end_dt
        LEFT JOIN project_master ON project.pid = project_master.pid
        SET 
            ${setClauses.join(",\n            ")}
        WHERE 1=1
    `;

    if (params.uuid) {
        updateQuery += ` AND finance.uuid = '${params.uuid}' `;
    }

    if (params.checkDate) {
        updateQuery += ` AND month(_d) = ${params.checkDate.getMonth() + 1} AND year(_d) = ${params.checkDate.getFullYear()}`;
    }

    if (params.rate) {
        updateQuery += ` AND project.rate = ${params.rate} `;
    }
    console.log("updateQuery:", updateQuery);

    // Build a SELECT query to fetch updated rows
    let selectQuery = `
        SELECT 
            finance.uuid, 
            invoice_no, 
            _ts_invoice, 
            _ts_invoice_due, 
            SUM(project.rate * finance.hrs) AS bill, 
            SUM(hrs) AS hrs, 
            SUM(IFNULL(finance.payment, 0)) AS payment,
            finance.created_by,
            finance.updated_by
        FROM finance
        LEFT JOIN project ON finance.uuid = project.uuid AND finance.pid = project.pid AND finance._d BETWEEN project.start_dt AND project.end_dt
        LEFT JOIN project_master ON project.pid = project_master.pid
        WHERE 1=1
    `;

    if (params.uuid) {
        selectQuery += ` AND finance.uuid = '${params.uuid}' `;
    }

    if (params.checkDate) {
        selectQuery += ` AND month(_d) = ${params.checkDate.getMonth() + 1} AND year(_d) = ${params.checkDate.getFullYear()}`;
    }

    if (params.rate) {
        selectQuery += ` AND project.rate = ${params.rate} `;
    }

    selectQuery += ` GROUP BY finance.uuid, invoice_no, _ts_invoice, _ts_invoice_due`;

    console.log("selectQuery:", selectQuery);

    try {
        // First, run the UPDATE
        await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: updateQuery,
                params: ["finance"],
            }),
        });

        // Then, fetch the updated rows
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: selectQuery,
                params: ["finance"],
            }),
        });

        // Return the fetched data
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function generateWeeklyInvoice(params: InvoiceRequestParams) {
    console.log(params);

    let _q = "UPDATE finance SET `invoice_no` = CONCAT('" + params.invoiceNo + "-', WEEK(_d, 1)) , _ts_invoice = '" + moment(new Date()).add(0, "M").format("YYYY-MM-DD") + "', _ts_invoice_due = '" + moment(new Date()).add(1, "M").format("YYYY-MM-DD") + "' where 1=1 ";

    if (params.uuid) {
        _q += " and uuid = '" + params.uuid + "' ";
    }

    if (params.checkDate) {
        // _q += " and month(_d) = " + (params.checkDate.getMonth() + 1); FIXME No month grouping for weekly invoices
        _q += " and year(_d) = " + params.checkDate.getFullYear();
    }

    if (params.week) {
        _q += " and WEEK(_d, 1) = " + params.week;
    }

    // _q += " group by WEEK(_d)";

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function markVerified(params: InvoiceRequestParams) {
    // console.log(params);

    let _q = "UPDATE finance SET `verified` = " + params.verified + ", _ts_verify = '" + moment().format("YYYY-MM-DD") + "' where 1=1 ";

    if (params.uuid) {
        _q += " and uuid = '" + params.uuid + "' ";
    }

    if (params.checkDate) {
        _q += " and month(_d) = " + (params.checkDate.getMonth() + 1) + " and year(_d) = " + params.checkDate.getFullYear();
    }

    // console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function performPaymentAPI(params: InvoiceRequestParams) {
    console.log(params);

    // Calculate the correct payment per day with deductions applied
    let paymentValue;
    if (params?.payment !== undefined && params?.payment !== null && params.payment > 0) {
        // If a specific payment amount is provided, use it as the per-day payment
        paymentValue = params.payment;
    } else {
        // Calculate payment with deductions applied
        // payment = (rate * hrs) - ((rate * hrs) * (insurance_fee + vmo) / 100)
        paymentValue = `(${params.rate} * hrs) - ((${params.rate} * hrs) * (COALESCE(project.insurance_fee, 0) + COALESCE(project.vmo, 0)) / 100)`;
    }

    let _q = `UPDATE finance 
              LEFT JOIN project ON finance.uuid = project.uuid AND finance.pid = project.pid AND finance._d BETWEEN project.start_dt AND project.end_dt
              SET payment = ${paymentValue}, _ts_payment = '${moment().format("YYYY-MM-DD")}' 
              where 1=1 `;

    if (params.uuid) {
        _q += ` and finance.uuid = '${params.uuid}' `;
    }

    if (params.checkDate) {
        _q += "  and year(finance._d) = " + params.checkDate.getFullYear();
    }

    if (params.billingPeriod !== "Weekly") {
        _q += ` and month(finance._d) =  '${params.checkDate.getMonth() + 1}' `;
    }

    if (params.invoiceNo) {
        _q += " and finance.invoice_no = '" + params.invoiceNo + "' ";
    }

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function getMonthlyInvoice(params: InvoiceRequestParams) {
    console.log(params);

    let _q = `
    SELECT  invoice_no, _ts_invoice, min(_ts_invoice) as _ts_invoice_label, _d, COUNT(f.hrs) AS _punched,  
    _ts_invoice_due, count(_d), p.rate, 
    
    sum(f.hrs * p.rate) as _sbill, 
    sum(payment) as _spayment, 
    sum(hrs) as _shrs,
    consultant.fixed_payroll,

    p.fixed_payment

    from finance as f 
    LEFT JOIN consultant ON consultant.uuid = f.uuid 
    left join project as p on f.uuid = p.uuid AND f.pid = p.pid AND f._d BETWEEN p.start_dt AND p.end_dt
    WHERE 1=1 `;

    _q += " AND f.hrs > 0 ";

    if (params.uuid) {
        _q += "  AND f.uuid = '" + params.uuid + "' ";
    }

    if (params.checkDate) {
        _q += " AND month(_d) = " + (params.checkDate.getMonth() + 1) + " and year(_d) = " + params.checkDate.getFullYear();
    }

    _q += " GROUP BY month(_d) HAVING _punched > 0";
    _q += " order by _d desc, invoice_no desc";

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });

        const rows = await response.json(); // your DB fetch

        // console.log("Rows fetched:", rows);

        // Post-process rows
        const processedRows = await Promise.all(
            rows.map(async (row) => {
                console.log("Processing row:", row);

                const year = moment(row._d).year();
                const month = moment(row._d).month() + 1; // moment: 0-based

                // Working Days Calculation
                let workingDays = await getWorkingDaysInMonth(year, month);
                row.workingDays = workingDays;

                if (row.fixed_payment && row.fixed_payment > 0) {
                    try {
                        const effortsDetails = await getEffortsDetails({
                            _d: moment(row?._d)
                                .set("year", Number(year))
                                .set("month", Number(month) - 1),
                            uuid: params?.uuid,
                        });
                        console.error(effortsDetails);

                        if (effortsDetails) {
                            // && effortsDetails.length > 0 // FIXME
                            // console.log("Efforts details for row:", row, "is", effortsDetails);
                            // Any logic that depends on effortsDetails should go here

                            row.effortsDetails = effortsDetails;
                            row.workingDays = effortsDetails && effortsDetails[0]?.working_days; // Use fetched working days or fallback to calculated

                            workingDays = effortsDetails && effortsDetails[0]?.working_days; // Use fetched working days or fallback to calculated
                        }

                        // console.log(row);
                    } catch (error) {
                        console.error("Error fetching efforts details:", error);
                    }

                    row._sbill = (Number(row.fixed_payment) / Number(workingDays)) * Number(row._punched);
                    row.diff = (Number(row.fixed_diff) / Number(workingDays)) * Number(row._punched);
                    row.billPerDay = Number(row.fixed_payment) / Number(workingDays);
                }

                console.log("Row after processing:", row);

                return {
                    ...row,
                };
            })
        );

        return processedRows;
    } catch (error) {
        return [];
    }
}

export async function getMonthlyItemizedInvoice(params: InvoiceRequestParams) {
    console.log(params);

    const startOfMonth = moment(params.checkDate).startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment(params.checkDate).endOf("month").format("YYYY-MM-DD");

    let _q = "with recursive all_dates(dt) as (select '" + startOfMonth + "' dt union all select dt + interval 1 day from all_dates where dt < '" + endOfMonth + "') ";

    _q +=
        "  SELECT p.vmo as vmo, p.insurance_fee as insurance_fee, invoice_no, _ts_invoice, min(_ts_invoice) as _ts_invoice_label, _d,  _ts_invoice_due,  p.rate, max(p.rate) as maxrate, MIN(cd.dt) as first_day_of_week, MAX(cd.dt) as last_day_of_week, WEEK(_d, 5) _date, count(_d) as _count, sum(p.rate * ft.hrs) as _sbill, sum(payment) as _spayment, sum(paid) as _spaid, sum(verified), COALESCE(sum(hrs), 0) as _shrs from all_dates cd left join finance ft on ft._d = cd.dt and uuid = '" +
        params.uuid +
        "' AND month(_d) = " +
        (params.checkDate.getMonth() + 1) +
        " and year(_d) = " +
        params.checkDate.getFullYear() +
        " left join project p on ft.uuid= p.uuid and dt between p.start_dt and p.end_dt left join project_master pm on pm.pid = p.pid group by WEEK(cd.dt, 5)";

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}
// method not used
export async function getMonthlyItemizedInvoiceOld(params: InvoiceRequestParams) {
    console.log(params);

    let _q = "SELECT invoice_no, _ts_invoice, _d,  _ts_invoice_due,  rate, MIN(_d) as first_day_of_week, MAX(_d) as last_day_of_week, WEEK(_d) _date, count(_d) as _count, sum(bill) as _sbill, sum(payment) as _spayment, sum(paid) as _spaid, sum(verified), sum(hrs) as _shrs from finance where uuid = '" + params.uuid + "' AND month(_d) = " + (params.checkDate.getMonth() + 1) + " and year(_d) = " + params.checkDate.getFullYear() + " group by WEEK(_d)";
    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function getWeeklyInvoice(params: InvoiceRequestParams) {
    console.log(params);

    let _q =
        "SELECT invoice_no, _ts_invoice, min(_ts_invoice) as _ts_invoice_label, _d,  _ts_invoice_due,  project.rate, MIN(_d) as first_day_of_week, MAX(_d) as last_day_of_week, WEEK(_d) _date, count(_d) as _count, sum(project.rate * finance.hrs) as _sbill, sum(payment) as _spayment, sum(paid) as _spaid, sum(verified), sum(hrs) as _shrs from finance left join project on finance.uuid = project.uuid where  finance.hrs > 0 and finance.uuid = '" +
        params.uuid +
        "' AND month(_d) = " +
        (params.checkDate.getMonth() + 1) +
        " and year(_d) = " +
        params.checkDate.getFullYear() +
        " AND week(_d)=" +
        params.week +
        " group by WEEK(_d)";
    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}
// // no need to change since finance contains pid
export async function getFinances(currMonth: any, curryear: any, uuid: any, pid: any, setIsLoading: any) {
    setIsLoading(true);
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "SELECT  hrs,DAY(_d) as day,WEEK(_d) as week, _d , uuid, pid, paid, rate, hrs, bill, payment, verified, name from finance where  MONTH(_d) = " + currMonth + " AND YEAR(_d) = " + curryear + " and uuid ='" + uuid + "' and pid = '" + pid + "'",
                // query: "SELECT  f.hrs,  DAY(f._d) AS day,  WEEK(f._d, 4) AS week, f._d,   f.uuid,  f.pid,   f.verified,  p.start_dt, p.end_dt FROM finance f JOIN project p ON f.pid = p.pid WHERE MONTH(f._d) =  " + currMonth + " AND YEAR(_d) = " + curryear + " and f.uuid ='" + uuid + "' and pid = '" + pid + "'",
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function getWorkingDaysData() {
    console.log("Fetching working days data...");
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "SELECT wd.uuid, wd.month_year, wd.working_days, c.name as employee_name FROM working_days wd LEFT JOIN consultant c ON wd.uuid = c.uuid ORDER BY wd.month_year DESC, c.name, wd.uuid",
                params: ["working_days"],
            }),
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        return await response.json();
    } catch (error) {
        console.error("Error fetching working days:", error);
        return [];
    }
}

export async function updateWorkingDaysData(uuid: string, monthYear: string, workingDays: number) {
    console.log("Updating working days data...", { uuid, monthYear, workingDays });
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: `UPDATE working_days SET working_days = ${workingDays} WHERE uuid = '${uuid}' AND month_year = '${monthYear}'`,
                params: ["working_days"],
            }),
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        return await response.json();
    } catch (error) {
        console.error("Error updating working days:", error);
        throw error;
    }
}
